import alimentador from './icons/alimentador.png';
import transformador from './icons/transformador.png';
//import subestacion from './icons/subestacion.png';
//import pmgd from './icons/pmgd.png';
//import consumo from './icons/consumo.png';
//import techoFv from './icons/techo-fv.png';
//import gd from './icons/gd.png';
import poste from './icons/poste.png';
import equipoOperacionControl from './icons/equipo-operacion-control.png';

import { SimpleObject } from '../../types';

export const SOURCE_IDS = {
  polygon: 'polygons-0',
  lines: 'lines-0',
  points: 'points-0'
};

export const LAYERS = {
  polygonFill: 'polygons-0-fill',
  polygonBorder: 'polygons-0-border',
  lines: 'lines-0',
  points: 'points-0'
};

export const ARTIFACTS_FIELD_ORDER = {
  'Transformador de distribucion': [
    'artefacto',
    //'empresa_id',
    'empresa_nombre',
    //'subestacion_id',
    'subestacion_nombre',
    //'alimentador_id',
    'alimentador_nombre',
    'identificador_del_transformador',
    'capacidad_nominal_kva',
    'voltaje_terminal_primario_kv',
    'voltaje_terminal_secundario_kv',
    'reactancia_porcentual',
    'tipo_conexion',
    'nodo_alta_tension_id',
    'nodo_baja_tension_id',
    'demanda_minima_dia',
    'demanda_minima_noche',
    'demanda_maxima'
  ],
  Linea: [
    'artefacto',
    //'empresa_id',
    'empresa_nombre',
    //'alimentador_id',
    'alimentador_nombre',
    'tramo_id',
    'tension_kv',
    'largo_metros',
    'numero_de_fases',
    'disposicion',
    'tipo_de_conductor'
  ],
  Poste: [
    'artefacto',
    //'empresa_id',
    'empresa_nombre',
    //'alimentador_id',
    'alimentador_nombre',
    'comuna',
    'poste_id',
    'tension',
    'altura',
    'disposicion_postacion'
  ],
  'Equipo de operacion y control': [
    'artefacto',
    //'empresa_id',
    'empresa_nombre',
    //'alimentador_id',
    'alimentador_nombre',
    'equipo_id',
    'nombre_del_equipo',
    'nodo',
    'estado',
    'tension_nominal',
    'tipo_de_equipo',
    'propiedad',
    'ubicacion',
    'capacidad_diseno',
    'tramo'
  ],
  Alimentador: [
    'artefacto',
    //'empresa_id',
    'empresa_nombre',
    //'subestacion_id',
    'subestacion_nombre',
    //'alimentador_id',
    'alimentador_nombre',
    'transformador_poder_id',
    'barra_mt_id',
    'capacidad_diseno',
    'tension_nominal',
    //'r1',
    //'x1',
    //'r0',
    //'x0',
    'demanda_minima_kw',
    'demanda_maxima_kw'
  ]
} as SimpleObject;

// THIS IS THE ZOOM LEVEL TO START TO SHOW EACH LAYER
export const LAYER_VISIBILITY_ZOOM = {
  lines: {
    minzoom: 12
  },
  points: {
    minzoom: 16
  },
  polygon: {
    minzoom: 6,
    maxzoom: 12 // El layer desaparecerá a partir de este nivel de zoom
  }
};

// WARNING: ONLY WILL BE DRAWN ARTIFACTS (POINTS) THAT ARE DEFINED IN HERE
export const ARTIFACTS_ICON_DICTIONARY = {
  'Transformador de distribucion': transformador,
  Poste: poste,
  'Equipo de operacion y control': equipoOperacionControl,
  Alimentador: alimentador
};
